import { Badge } from 'ui';

type QuantityBadgeProps = {
  inventoryStatus: string;
};

const QuantityBadge = ({ inventoryStatus }: QuantityBadgeProps) => {
  return (
    <Badge type={inventoryStatus === 'sold out' ? 'error' : 'warning'}>{inventoryStatus}</Badge>
  );
};

export { QuantityBadge };
